import { isPhone } from '../constants/mediaqueries';
export default function popUp() {
    var pixel = document.getElementById('pop-up-pixel');
    var popUpEl = document.getElementById('pop-up');
    var popUpBarEl = document.getElementById('pop-up-bar');
    if (!pixel || !popUpEl || !popUpBarEl)
        return;
    // check for sessionstorage
    var storageKey = 'pop-up';
    var storageData = sessionStorage.getItem(storageKey);
    if (storageData)
        return;
    // buttons
    var closePopUpButton = popUpEl === null || popUpEl === void 0 ? void 0 : popUpEl.querySelector('[data-id="hide-pop-up-bar"]');
    var closePopUpBarButton = popUpBarEl === null || popUpBarEl === void 0 ? void 0 : popUpBarEl.querySelector('[data-id="hide-pop-up-bar"]');
    var hidePopUp = function () {
        popUpEl.classList.add('pop-up--hide');
        // save
        sessionStorage.setItem(storageKey, 'hidden');
    };
    var hidePopUpBar = function () {
        popUpBarEl.classList.add('pop-up-bar--hide');
    };
    var showPopUp = function () {
        popUpEl.classList.remove('pop-up--hide');
        closePopUpButton === null || closePopUpButton === void 0 ? void 0 : closePopUpButton.addEventListener('click', function () {
            hidePopUp();
            hidePopUpBar();
        });
    };
    var showPopUpBar = function () {
        popUpBarEl.classList.remove('pop-up-bar--hide');
        popUpBarEl.addEventListener('click', function (e) {
            if (e.target.nodeName !== 'BUTTON') {
                showPopUp();
                hidePopUpBar();
            }
        });
        closePopUpBarButton === null || closePopUpBarButton === void 0 ? void 0 : closePopUpBarButton.addEventListener('click', function (e) {
            if (e.target.nodeName === 'BUTTON') {
                hidePopUpBar();
                hidePopUp();
            }
        });
    };
    var config = {
        rootMargin: '0px 0px 0px 0px',
    };
    var onIntersecting = function (entries, observer) {
        entries.forEach(function (entry) {
            var isIntersecting = entry.isIntersecting, target = entry.target;
            if (isIntersecting) {
                if (isPhone()) {
                    showPopUpBar();
                }
                else {
                    showPopUp();
                }
                // unobserve
                observer.unobserve(target);
            }
        });
    };
    var intersectionObserver = new IntersectionObserver(onIntersecting, config);
    intersectionObserver.observe(pixel);
}
